import type { ReactNode } from 'react';
import { newClientEmailMissing } from '@ehr/shared';
import { ApiError } from './api.js';

/**
 * ehr#757: the Add client window's required fields. First name, Last name (always), and for a
 * client Mobile phone (#734) and Primary email (#757). Their labels end in a red star, the same
 * marker as the Demographics drawer (`.demo-req`).
 */

export { newClientEmailMissing };

/** The line shown at the bottom of the window when a client's email is left blank. */
export const NEW_CLIENT_EMAIL_PROMPT = 'Enter a primary email before saving.';

/** Is this Add client field required for a contact of this category? */
export function newClientFieldRequired(key: string, category: string): boolean {
  if (key === 'first_name' || key === 'last_name') return true;
  return category === 'client' && (key === 'phone' || key === 'email');
}

/** A field label, with a red star when the field is required (the label's own "*" is dropped). */
export function newClientLabel(key: string, label: string, category: string): ReactNode {
  const text = label.replace(/\s*\*$/, '');
  if (!newClientFieldRequired(key, category)) return text;
  return (
    <>
      {text}
      <span className="demo-req">*</span>
    </>
  );
}

/** True when the server refused the new contact for having no email (CONTACT_FIELD_REQUIRED). */
export function newClientEmailRefused(e: unknown): boolean {
  if (!(e instanceof ApiError) || e.code !== 'CONTACT_FIELD_REQUIRED') return false;
  const fields = (e.details as { fields?: unknown } | undefined)?.fields;
  return Array.isArray(fields) && fields.includes('email');
}
